/**
 * עמלת HR (מרווח חברה) להצגה בהזמנת LDS/חבילה.
 * תואם לשרשרת TRACE: initialPrice → priceWithCommission.
 * שדה hrCommission=0 נחשב חסר (לא חוסם fallback).
 */

function tryParseJsonObject(raw) {
  if (raw == null || typeof raw !== "string") return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : null;
  } catch {
    return null;
  }
}

/** אותו מקור ourPrice כמו TRACE / resolveLdsOrderFinalPriceBreakdown. */
export function resolveLdsOrderOurPriceBlock(order) {
  if (!order || typeof order !== "object") return {};
  const flightNode =
    order.flights && typeof order.flights === "object" && !Array.isArray(order.flights)
      ? order.flights
      : null;
  const rawOp =
    flightNode?.ourprice ??
    flightNode?.ourPrice ??
    order.ourprice ??
    order.ourPrice;
  if (rawOp && typeof rawOp === "object" && !Array.isArray(rawOp)) return rawOp;
  return tryParseJsonObject(rawOp) || {};
}

function pickPositiveMoney(...candidates) {
  for (const v of candidates) {
    if (v == null || v === "") continue;
    const n = typeof v === "number" ? v : parseFloat(v);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return null;
}

function round2(n) {
  return Math.round(n * 100) / 100;
}

/**
 * @param {Record<string, unknown>|null|undefined} order
 * @returns {number} סכום עמלת HR בש״ח (0 אם אין מרווח)
 */
export function resolveLdsOrderHrCommissionIls(order) {
  if (!order || typeof order !== "object") return 0;

  const op = resolveLdsOrderOurPriceBlock(order);
  const tf =
    op.ourTotalFare && typeof op.ourTotalFare === "object" ? op.ourTotalFare : {};

  const fromField = pickPositiveMoney(
    tf.hrCommission,
    op.hrCommission,
    tf.unifiedHrMargin,
    op.unifiedHrMargin
  );
  if (fromField != null) return fromField;

  const initial = pickPositiveMoney(tf.initialPrice, op.initialPrice);
  const pwc = pickPositiveMoney(tf.priceWithCommission, op.priceWithCommission);
  if (initial != null && pwc != null && pwc > initial) {
    return round2(pwc - initial);
  }

  const legacyComm = order.commisions || order.commissions;
  const fromLegacy = pickPositiveMoney(
    legacyComm && typeof legacyComm === "object" ? legacyComm.hr : null
  );
  if (fromLegacy != null) return fromLegacy;

  return 0;
}
